// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1zWwu","fileBtn":"File_fileBtn__1Ckne","closeBtn":"File_closeBtn__xLaFM","fileSelected":"File_fileSelected__PBo1x","disabled":"File_disabled__1z4Wr"};